<script setup>
import {watch} from "vue";
import {toastStore} from "../stores/ToastStore";

watch(() => toastStore.isOpened, (value) => {
    if (value) {
        const toastEl = document.querySelector('.toast')
        const toast = new bootstrap.Toast(toastEl);
        toast.show();
        setTimeout(() => {
            toastStore.setIsOpened(false);
        }, 5000); // The delay is in milliseconds. 5000ms equals 5 seconds.
    } else {
        const toastEl = document.querySelector('.toast')
        const toast = new bootstrap.Toast(toastEl);
        toast.hide();
        toastStore.setIsOpened(false);
    }
});
</script>
<template>
    <div aria-live="polite" aria-atomic="true" class="position-relative">
        <div class="toast-container position-fixed top-0 end-0 mt-5 p-3">
            <div class="toast align-items-center text-bg-primary border-0" role="alert" aria-live="assertive"
                 aria-atomic="true">
                <div class="d-flex">
                    <div class="toast-body">
                        {{ toastStore.message }}
                    </div>
                    <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                            @click="toastStore.setIsOpened(false)"
                            aria-label="Close"></button>
                </div>
            </div>
        </div>
    </div>
</template>
